export const modifierList = ['success', 'failure'];
